export const environment = {
  production: false,
  apiUrl: 'http://localhost:1104/api'
};

